import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment-duration-format';

//import update from "immutability-helper";
//import moment from 'moment';

//- Material UI / Style
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { getGlobalClasses } from '../../themes';

//containers
import AuthUserContainer from '../../containers/AuthUser';
import TimeClockPermissionContainer from '../../containers/TimeClock/TimeClockPermission';
import LateAnalysisContainer from '../../containers/Reporting/LateAnalysis';
import localStorage from '../../libs/localStorage';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';

//- UI / Form
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import SearchIcon from '@material-ui/icons/Search';
import CircularProgress from '@material-ui/core/CircularProgress';

import FormDatePicker from '../../components/form/FormDatePicker';
// import UserPicker from "../../components/advancedForm/UserPicker";
import FormComponent from '../../components/FormComponent';
import DownloadIcon from '@material-ui/icons/CloudDownload';
// import FormCheckbox from "../../components/form/FormCheckbox";
import SectionHeader from '../../components/SectionHeader';
import EnhancedTable from '../../components/table/EnhancedTable';
import { statuses } from '../../components/FleetCalendar/WorkDayStatuses';
import LocationMultiSelect from '../../components/advancedForm/LocationMultiSelect';
import UserPicker from '../../components/advancedForm/UserPicker';

import {
	// pToC,
	// lateToColor,
	// formatPercentage,
	// noNsToColor,
	// missingToColor,
	veryLateToColor,
	daysOnTimeToColor,
} from './lateAnalysisHelper';

const isLocalhost = Boolean(window.location.hostname === 'localhost');

const isWorkingStatusMap = {};
const statusToDisplay = {};
statuses.forEach(({ value, display, isWorking }) => {
	if (isWorking) {
		isWorkingStatusMap[value] = true;
	}
	statusToDisplay[value] = display;
});

function formatDiff(diff) {
	if (diff <= 0) {
		return `${Math.abs(_.round(diff))} min early`;
	} else {
		return `${Math.abs(_.round(diff))} min late`;
	}
}

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		submitButton: {
			marginTop: 20,
			fontSize: 16,
			borderRadius: '100px',
			padding: '13px 45px',
			textTransform: 'uppercase',
			marginRight: 10,
		},
		icon: {
			paddingRight: 5,
		},
		oddRow: {
			backgroundColor: '#f9f9f9',
		},
		resultsHere: {
			padding: 30,
			backgroundColor: '#f1f1f1',
			color: '#777',
			borderRadius: 10,
		},
		runningSearch: {
			paddingLeft: 20,
			display: 'flex',
			alignItems: 'center',
			fontSize: 18,
			color: '#666',
		},
		button: {
			marginRight: 5,
		},
		eventsContainer: {
			padding: 20,
		},
		eventContainer: {
			borderTop: '1px solid #eee',
			marginTop: 5,
			paddingTop: 5,
		},
		eventNote: {},
		eventDateTime: {
			fontSize: '80%',
			color: '#666',
		},
		removeButton: {
			verticalAlign: 'middle',
			padding: '8px 10px',
		},
		detailLink: {
			textDecoration: 'none',
			fontWeight: 500,
		},
		dateRange: {
			marginRight: 10,
		},
	};
};

let cacheLastRun = {};
function storeKey(key) {
	return `/lateAnalysis-${key}`;
}

function TabPanel(props) {
	const { children, value, index } = props;

	return (
		<div
			style={{
				paddingTop: 20,
				paddingLeft: 10,
				paddingRight: 10,
				display: value === index ? 'block ' : 'none',
			}}
		>
			<Box>{children}</Box>
		</div>
	);
}

class ShiftReports extends FormComponent {
	constructor(props) {
		super(props);

		const dateRange = localStorage.getItem(storeKey('dateRange')) || 'lastMonth';
		const { afterDate, beforeDate } = this.dateRangeToDates(dateRange);

		this.state = {
			dateRange,
			afterDate,
			beforeDate,
			order: 'asc',
			orderBy: 'clockInDateTime',
			isSearching: false,
			isClockOutEmployeeDialogOpen: false,
			isUpdateEmployeeDialogOpen: false,
			timeClockShiftForClockOut: undefined,
			isRemoveShiftDialogOpen: false,
			timeClockShiftForRemove: undefined,
			locationIds: localStorage.getItem(storeKey('locationIds')) || [1, 2, 3, 4, 5, 6, 7],
			userIds: localStorage.getItem(storeKey('userIds')) || [],
			refreshId: 1,
			selectedTabValue: 0,
			...cacheLastRun,
		};
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.state.locationIds !== prevState.locationIds) {
			localStorage.setItem(storeKey('locationIds'), this.state.locationIds);
		}

		if (this.state.userIds !== prevState.userIds) {
			localStorage.setItem(storeKey('userIds'), this.state.userIds);
		}
		if (this.state.dateRange !== prevState.dateRange) {
			localStorage.setItem(storeKey('dateRange'), this.state.dateRange);
		}
	}

	getApiParams = () => {
		const { accessToken } = this.props;
		const { userIds, locationIds, afterDate, beforeDate, selectedTabValue } = this.state;

		const params = {
			accessToken,
			afterDate: moment(afterDate).format('YYYY-MM-DD'),
			beforeDate: moment(beforeDate).format('YYYY-MM-DD'),
		};

		if (!_.isEmpty(locationIds) && selectedTabValue === 0) {
			params.locationIds = locationIds;
		}

		if (!_.isEmpty(userIds) && selectedTabValue === 1) {
			params.userIds = userIds;
		}

		return params;
	};

	handleSearch = () => {
		const { showErrors, runLateAnalysisReport } = this.props;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			return showErrors(_.values(formFieldError));
		}

		this.setState({
			isSearching: true,
			refreshId: this.state.refreshId + 1,
			hasResults: false,
		});

		runLateAnalysisReport({
			params: this.getApiParams(),
			callback: (err, r) => {
				this.setState({ isSearching: false });
				if (err) {
					return showErrors(_.isArray(err) ? err : [err]);
				}

				this.formatResults({ apiResults: r });
			},
		});
	};

	formatResults = ({ apiResults }) => {
		const { userMap, classes } = this.props;
		const { lateAnalysisRows } = apiResults;
		const formattedRows = [];
		const totalRow = {
			key: 'totalRow',
			driverDisplay: 'Total',

			daysBetween10and10: 0,
			daysBetween10and30Early: 0,
			daysBetween10and30Late: 0,
			daysOver30Early: 0,
			daysOver30Late: 0,

			daysOnSchedule: 0,
			daysNotOnSchedule: 0,
			daysOnScheduleButMissingSphereClockIn: 0,
		};

		statuses.forEach(({ value }) => {
			totalRow[value] = 0;
		});

		const averages = [];
		lateAnalysisRows.forEach((lateAnalysisRow) => {
			const {
				userId,
				daysOnSchedule,
				daysNotOnSchedule,

				daysOver30Early,
				daysBetween10and30Early,
				daysBetween10and10,
				daysBetween10and30Late,
				daysOver30Late,

				averageClockInDifference,
				daysOnScheduleButMissingSphereClockIn,
			} = lateAnalysisRow;

			const user = userMap[userId] || {
				firstName: 'Missing',
				lastName: userId,
			};

			averages.push(averageClockInDifference);
			const driverDisplay = `${user.firstName} ${user.lastName}`;
			const row = {
				key: `user_${userId}`,
				driverDisplay,

				daysOver30Early,
				daysBetween10and30Early,
				daysBetween10and10,
				daysBetween10and30Late,
				daysOver30Late,

				daysOnSchedule,
				daysNotOnSchedule,
				daysOnScheduleButMissingSphereClockIn,
				averageClockInDifference,
				averageClockInDifferenceDisplay: formatDiff(averageClockInDifference),
			};

			totalRow.daysBetween10and10 += daysBetween10and10;
			totalRow.daysBetween10and30Early += daysBetween10and30Early;
			totalRow.daysBetween10and30Late += daysBetween10and30Late;
			totalRow.daysOver30Early += daysOver30Early;
			totalRow.daysOver30Late += daysOver30Late;

			totalRow.daysOnSchedule += daysOnSchedule;
			totalRow.daysNotOnSchedule += daysNotOnSchedule;
			totalRow.daysOnScheduleButMissingSphereClockIn += daysOnScheduleButMissingSphereClockIn;

			const style = {
				backgroundColor: daysOnTimeToColor(daysBetween10and10 / daysOnSchedule),
			};
			row.percentageWorkedStyle = style;

			row.veryEarlyStyle = {
				backgroundColor: veryLateToColor(daysOver30Early),
			};

			row.veryLateStyle = {
				backgroundColor: veryLateToColor(daysOver30Late),
			};

			const { afterDate, beforeDate } = this.state;
			row.detailDisplay = (
				<Button
					alt="details"
					color="primary"
					variant="outlined"
					className={classes.detailLink}
					onClick={() => {
						this.props.history.push(
							`/reports/lateAnalysis/details/${userId}/${afterDate}/${beforeDate}`
						);
					}}
				>
					Details
				</Button>
			);
			formattedRows.push(row);
		});

		totalRow.averageClockInDifference = _.mean(averages);
		totalRow.averageClockInDifferenceDisplay = formatDiff(totalRow.averageClockInDifference);

		cacheLastRun = { formattedRows, totalRows: [totalRow], hasResults: true, isSearching: false };
		this.setState({ formattedRows, totalRows: [totalRow], hasResults: true, isSearching: false });
	};

	handleTabChange = (event, selectedTabValue) => {
		this.setState({ selectedTabValue });
	};

	handleChangeIndex = (index) => {
		this.setState({ index });
	};

	render() {
		const {
			classes,
			permissions,
			//myTimeClockPermissions,
			//myCanViewUserIds,
			// myCanModifyUserIds,
		} = this.props;

		const { hasResults } = this.state;

		if (!permissions || !_.includes(permissions, 'canRunAttendanceReports')) {
			return <div>You do not have valid permissions to view this page.</div>;
		}

		const params = this.getApiParams();
		params.downloadCsv = true;
		const request = {
			method: 'reporting.driver.run',
			params,
		};

		const domain = isLocalhost ? 'http://localhost:3702' : '';
		const downloadUrl = `${domain}/api?request=${JSON.stringify(request)}`;

		const { dateRange } = this.state;
		let disabled = true;
		if (dateRange === 'custom') {
			disabled = false;
		}

		const { selectedTabValue } = this.state;

		const isRequired = true;
		return (
			<form>
				<div className={classes.globalMainHeadline}>Driver Late Analysis</div>
				<Paper className={classes.globalMainPaper} style={{ minHeight: 500 }}>
					<Grid spacing={2} container>
						<Grid item xs={12} sm={11} md={9}>
							<Grid spacing={2} container>
								<SectionHeader label="User Filter" gridProps={{ md: 12 }} isTop={true} />
								<div style={{ border: '1px solid #ccc', padding: '10px', width: '100%' }}>
									<Grid item xs={12}>
										<Tabs
											value={selectedTabValue}
											indicatorColor="primary"
											textColor="primary"
											onChange={this.handleTabChange}
											style={{ borderBottom: '1px solid #eee' }}
										>
											<Tab label="Terminals" />
											<Tab label="Drivers" />
										</Tabs>
									</Grid>
									<Grid item xs={12} style={{ padding: 20, paddingBottom: 40 }}>
										<TabPanel value={selectedTabValue} index={0}>
											<LocationMultiSelect {...this.setForm('locationIds', 'Terminals')} />
										</TabPanel>

										<TabPanel value={selectedTabValue} index={1}>
											<UserPicker
												{...this.setForm('userIds', 'Drivers')}
												selectMultiple={true}
												whoToShow={'driversOnly'}
												//includeHidden={true}
											/>
										</TabPanel>
									</Grid>
								</div>

								<SectionHeader label="Date Filter" gridProps={{ md: 12 }} />
								<Grid item md={12} style={{ display: 'flex' }}>
									{this.renderDateButton('Past 30 days', 'past30')}
									{this.renderDateButton('Past 60 days', 'past60')}
									{this.renderDateButton('Last Month', 'lastMonth')}
									{this.renderDateButton('Past 3 months', 'past90')}
									{this.renderDateButton('Custom', 'custom')}
								</Grid>
								<FormDatePicker
									{...this.setForm('afterDate', 'Days after this date (start)', isRequired)}
									format={'M/D/YYYY'}
									gridProps={{ md: 6 }}
									disabled={disabled}
								/>
								<FormDatePicker
									{...this.setForm('beforeDate', 'Days before this date (end)', isRequired)}
									format={'M/D/YYYY'}
									gridProps={{ md: 6 }}
									disabled={disabled}
								/>
								<Grid item xs={12} style={{ padding: '20px 0px' }}>
									<div style={{ direction: 'row', display: 'flex' }}>
										<Button
											onClick={this.handleSearch}
											variant="contained"
											color="primary"
											className={classes.submitButton}
											disabled={this.state.isSearching}
											style={{ marginRight: 10 }}
										>
											<SearchIcon className={classes.icon} />
											Run Report
										</Button>

										<a
											href={downloadUrl}
											style={{ textDecoration: 'none', paddingRight: 5 }}
											target="_blank"
											rel="noreferrer noopener"
										>
											<Button variant="contained" color="primary" className={classes.submitButton}>
												<DownloadIcon className={classes.icon} />
												Search & Download Report
											</Button>
										</a>

										{this.state.isSearching && (
											<div className={classes.runningSearch}>
												<CircularProgress />
												<span style={{ paddingLeft: 10 }}>Searching...</span>
											</div>
										)}
									</div>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Paper>

				<Paper className={classes.globalMainPaper}>
					{!hasResults && <div className={classes.resultsHere}>Results here</div>}
					{hasResults && this.renderResults()}
				</Paper>
			</form>
		);
	}

	setDateRange = (dateRange) => {
		const { afterDate, beforeDate } = this.dateRangeToDates(dateRange);
		if (!afterDate) {
			this.setState({ dateRange });
		} else {
			this.setState({ dateRange, afterDate, beforeDate });
		}
	};

	dateRangeToDates = (dateRange) => {
		if (dateRange === 'past30') {
			return {
				beforeDate: moment().subtract(1, 'day').format('YYYY-MM-DD'),
				afterDate: moment().subtract(31, 'days').format('YYYY-MM-DD'),
			};
		} else if (dateRange === 'past60') {
			return {
				beforeDate: moment().subtract(1, 'day').format('YYYY-MM-DD'),
				afterDate: moment().subtract(61, 'days').format('YYYY-MM-DD'),
			};
		} else if (dateRange === 'lastMonth') {
			return {
				afterDate: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
				beforeDate: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
			};
		} else if (dateRange === 'past90') {
			return {
				beforeDate: moment().subtract(1, 'day').format('YYYY-MM-DD'),
				afterDate: moment().subtract(91, 'days').format('YYYY-MM-DD'),
			};
		} else if (dateRange === 'past6Months') {
			return {
				beforeDate: moment().format('YYYY-MM-DD'),
				afterDate: moment().subtract(6, 'months').format('YYYY-MM-DD'),
			};
		} else if (dateRange === 'pastYear') {
			return {
				beforeDate: moment().format('YYYY-MM-DD'),
				afterDate: moment().subtract(1, 'year').format('YYYY-MM-DD'),
			};
		} else {
			return {};
		}
	};

	renderDateButton = (label, range) => {
		const { classes } = this.props;
		const { dateRange } = this.state;

		const variant = dateRange === range ? 'contained' : 'outlined';

		return (
			<Button
				className={classes.dateRange}
				variant={variant}
				color="primary"
				onClick={() => {
					this.setDateRange(range);
				}}
			>
				{label}
			</Button>
		);
	};

	handleSort = (orderBy) => {
		let order = 'desc';
		if (this.state.orderBy === orderBy && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order: order, orderBy: orderBy });
	};

	renderResults = () => {
		const { formattedRows, totalRows } = this.state;
		if (!formattedRows) {
			return null;
		}

		const columns = [
			{
				label: 'Driver',
				sortId: 'driverDisplay',
				displayId: 'driverDisplay',
			},
			{
				label: 'Days On',
				sortId: 'daysOnSchedule',
				displayId: 'daysOnSchedule',
			},
			{
				label: 'Days Off',
				sortId: 'daysNotOnSchedule',
				displayId: 'daysNotOnSchedule',
			},
			{
				label: ['Days On Time', '(10 to 10)'],
				sortId: 'daysBetween10and10',
				displayId: 'daysBetween10and10',
				useStyle: 'percentageWorkedStyle',
			},
			{
				label: ['Days Early', '(10 to 30 min)'],
				sortId: 'daysBetween10and30Early',
				displayId: 'daysBetween10and30Early',
			},
			{
				label: ['Days Late', '(10 to 30 min)'],
				sortId: 'daysBetween10and30Late',
				displayId: 'daysBetween10and30Late',
			},
			{
				label: ['Days Very Early', '(over 30 min)'],
				sortId: 'daysOver30Early',
				displayId: 'daysOver30Early',
				useStyle: 'veryEarlyStyle',
			},
			{
				label: ['Days Very Late', '(over 30 min)'],
				sortId: 'daysOver30Early',
				displayId: 'daysOver30Early',
				useStyle: 'veryLateStyle',
			},
			{
				label: ['Average Difference', '(in minutes)'],
				sortId: 'averageClockInDifference',
				displayId: 'averageClockInDifferenceDisplay',
			},
			{
				label: 'Missing Clock In',
				sortId: 'daysOnScheduleButMissingSphereClockIn',
				displayId: 'daysOnScheduleButMissingSphereClockIn',
				useStyle: 'missingStyle',
			},
			{
				label: 'Details',
				noSort: true,
				displayId: 'detailDisplay',
			},
		];

		//	col.useStyle = 'noCallNoShowStyle';

		return (
			<EnhancedTable
				rows={formattedRows}
				totalRows={totalRows}
				columns={columns}
				isDense={true}
				defaultOrderBy={'percentageWorked'}
				defaultOrder={'desc'}
				refreshId={this.state.refreshId}
				makeSticky={true}
			/>
		);
	};
}

ShiftReports.propTypes = {
	runLateAnalysisReport: PropTypes.func.isRequired,
	userMap: PropTypes.object,

	showErrors: PropTypes.func.isRequired,
	authUser: PropTypes.object,
	classes: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles),
	AuthUserContainer,
	LateAnalysisContainer,
	TimeClockPermissionContainer,
])(ShiftReports);
